"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import API from "@ym-framework/api-utils";
import Validator from "../framework/components/form/validator";
const Fingerprint2 = require("fingerprintjs2");
import nocaptcha from "vue-nocaptcha/lib/nocaptcha.js";
const md5 = require("md5");
import { Base64 } from "js-base64";
import { Component, Vue, Ref } from "vue-property-decorator";
let TeamInviteLogin = class extends Vue {
  constructor() {
    super(...arguments);
    this.teamName = null;
    this.teamCode = null;
    this.status = "ready";
    this.rules = {
      nickname: [
        {
          required: true,
          message: "\u6635\u79F0\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165",
          trigger: "blur"
        }
      ],
      phone: [
        {
          required: true,
          message: "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165",
          trigger: "blur"
        },
        { validator: Validator.phone, trigger: "blur" }
      ],
      password: [
        {
          required: true,
          message: "\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165",
          trigger: "blur"
        }
      ],
      unlock: [{ required: true, message: "\u8BF7\u6ED1\u52A8\u9A8C\u8BC1", trigger: "blur" }]
    };
    this.formData = {
      nickname: "",
      phone: "",
      phone_prefix: "+86",
      password: "",
      unlock: "",
      remark: null
    };
    this.nohide = "no-captcha nc-container";
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("code")) {
        this.teamCode = this.$route.query.code;
      } else {
        this.$router.push("/");
        return;
      }
      this.formData.unlock = true;
      yield this.getTeamName();
    });
  }
  onLoad() {
    console.log("loaded");
  }
  onError() {
    console.log("error");
  }
  toDownload() {
    window.open(`https://www.kuajingvs.com/download`, "__blank");
  }
  getTeamName() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.app/api/v1/team/code/${this.teamCode}`
        );
        this.teamName = response.data.name;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  clicktoregister() {
    this.$router.push({
      path: "/team_invite/register",
      query: this.$route.query
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (yield this._teamInviteForm.validate()) {
          this.status = "submit";
          let _components = yield Fingerprint2.getPromise({
            fonts: { extendedJsFonts: true }
          });
          let _dist = {};
          for (let _item of _components) {
            _dist[_item.key] = _item.value;
          }
          let _speed = [
            _dist["audio"],
            _dist["availableScreenResolution"],
            _dist["colorDepth"],
            _dist["deviceMemory"],
            _dist["hardwareConcurrency"],
            _dist["plugins"],
            _dist["timezone"],
            _dist["userAgent"],
            _dist["canvas"],
            _dist["webgl"],
            _dist["webglVendorAndRenderer"]
          ];
          let _user_id = md5(Base64.encode(_speed.toString()));
          let response = yield API.post(`api://base.app/api/v6/auth`, {
            auth_id: this.formData.phone,
            phone_prefix: this.formData.phone_prefix,
            user_name: this.formData.nickname,
            device_mini: _user_id,
            invite_code: this.teamCode,
            password: this.formData.password,
            platform: "web",
            remark: this.formData.remark,
            type: "invite.join.team"
          });
          this.status = "ready";
          if (response.data.model === "account.session.joined.await") {
            this.$router.push({
              path: "/team_invite/success",
              query: this.$route.query
            });
            return;
          }
          if (response.data.model === "account.session.joined.notallow") {
            this.$router.push({
              path: "/team_invite/failed",
              query: this.$route.query
            });
            return;
          }
          if (response.data.model === "account.session.joined.notallowowner") {
            this.$router.push({
              path: "/team_invite/failed",
              query: this.$route.query
            });
            return;
          }
          if (response.data.model === "account.session.joined") {
            this.$router.push({
              path: "/team_invite/success",
              query: this.$route.query
            });
            return;
          }
          this.$router.push({
            path: "/team_invite/failed",
            query: this.$route.query
          });
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("teamInviteForm")
], TeamInviteLogin.prototype, "_teamInviteForm", 2);
TeamInviteLogin = __decorateClass([
  Component({
    components: {
      PasswordInput,
      nocaptcha
    }
  })
], TeamInviteLogin);
export {
  TeamInviteLogin as default
};
